module.exports = __webpack_public_path__ + "assets/33b5c6fbc3a49e055769faf17e2b6b26.svg";